const Label = ({
  name
}) => {

  return(
    <label className="form-label">{name}</label>
  )
}

export default Label